import { FormValues } from "@features/builder/graph/contextMenu/RenameDialog/schema"
import { Button, Divider, Stack, TextField } from "@mui/material"
import { useState } from "react"
import { useFormContext } from "react-hook-form"

/**
 * This component must be wrapped with form provider
 */
export function SearchAndReplace() {
  const [search, setSearch] = useState("")
  const [replace, setReplace] = useState("")

  const form = useFormContext<FormValues>()

  const handleSearchReplace = () => {
    if (!search) return

    const values = form.getValues()
    const newLabels = values.labels.map((item) => ({
      ...item,
      label: item.label.replaceAll(search, replace),
    }))

    form.setValue("labels", newLabels)
    form.clearErrors("labels")
  }

  return (
    <>
      <Stack direction="row" gap={2} m={2}>
        <TextField
          label="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          size="small"
          fullWidth
        />
        <TextField
          label="Replace"
          value={replace}
          onChange={(e) => setReplace(e.target.value)}
          size="small"
          fullWidth
        />
        <Button onClick={handleSearchReplace} variant="text" size="small">
          Replace
        </Button>
      </Stack>
      <Divider variant="middle" color="black" />
    </>
  )
}
